import { ajustarTamanhoFonte } from "./global";

// Cores adaptadas aos temas claro e escuro.
const corTitulo = (theme) =>
  theme.palette.mode === "dark" ? theme.palette.text.primary : "#102957";

const corDescricao = (theme) =>
  theme.palette.mode === "dark" ? theme.palette.text.secondary : "#58739b";

// Estilo reutilizado nas linhas do painel.
const linhaPreferencias = {
  display: "flex",
  alignItems: "center",
  gap: 1,
  mx: 0.25,
  px: 1.25,
  py: 1,
  minHeight: 64,
  borderRadius: 1.25,
  whiteSpace: "normal",

  "&:hover": {
    bgcolor: "action.hover",
  },
  "&.Mui-focusVisible": {
    bgcolor: "action.selected",
    outline: "2px solid",
    outlineColor: "primary.main",
    outlineOffset: -2,
  },
};

// Mantido para os popovers detalhados existentes.
export const painelPreferencias = {
  width: 328,
  maxWidth: "calc(100vw - 32px)",
  mt: 0.75,
  borderRadius: 1.5,
  border: "1px solid",
  borderColor: "divider",
  boxShadow: "0 4px 16px rgba(32,79,122,.14)",
};

// Painel principal.
export const painelMenuPreferencias = {
  ...painelPreferencias,

  width: 360,
  maxWidth: "calc(100vw - 24px)",
  maxHeight: "calc(100dvh - 32px)",

  borderRadius: 2,
  borderTop: "3px solid",
  borderTopColor: "var(--sear-acao-azul, #1976d2)",
  boxShadow: (theme) => theme.palette.mode === "dark"
    ? "0 8px 32px rgba(0,0,0,.32)"
    : "0 8px 32px rgba(26,48,78,.14)",
};

// Estilos específicos do menu de preferências.
export const estilosMenuPreferencias = {
  // CABEÇALHO
  cabecalho: {
    display: "flex",
    alignItems: "center",
    gap: 1.25,
    px: 1.25,
    py: 1.25,
    mb: 0.5,
    borderRadius: 1.5,
    bgcolor: "transparent",
  },

  iconeCabecalho: {
    width: 36,
    height: 36,
    flexShrink: 0,

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    borderRadius: 1.5,

    bgcolor: (theme) =>
      theme.palette.mode === "dark" ? "rgba(47,109,176,.24)" : "#e0f1ff",

    color: "primary.main",
  },

  tituloCabecalho: {
    fontSize: ajustarTamanhoFonte("17px"),
    fontWeight: 700,
    lineHeight: 1.3,
    color: corTitulo,
  },

  descricaoCabecalho: {
    mt: 0.25,
    fontSize: ajustarTamanhoFonte("12px"),
    lineHeight: 1.45,
    color: corDescricao,
  },

  // DIVISORES DE SEÇÃO
  secao: {
    display: "flex",
    alignItems: "center",
    gap: 1.5,

    px: 1.25,
    pt: 1,
    pb: 0.5,
    mt: 0.25,

    bgcolor: "transparent",
    color: corDescricao,

    fontSize: ajustarTamanhoFonte("12px"),
    fontWeight: 700,
    lineHeight: 1.5,

    "&::after": {
      content: '""',
      flex: 1,
      height: "1px",
      bgcolor: "divider",
    },
  },

  // LINHAS
  linha: linhaPreferencias,

  iconeLinha: {
    "&&": { minWidth: 28 },
    color: "primary.main",
    "& .MuiSvgIcon-root": { fontSize: 22 },
  },

  textoLinha: {
    flex: 1,
    minWidth: 0,
  },

  tituloLinha: {
    fontSize: ajustarTamanhoFonte("14px"),
    fontWeight: 600,
    lineHeight: 1.35,
    color: corTitulo,
    whiteSpace: "normal",
  },

  descricaoLinha: {
    mt: 0.25,
    fontSize: ajustarTamanhoFonte("12px"),
    lineHeight: 1.4,
    color: corDescricao,
    whiteSpace: "normal",
  },

  // PERCENTUAIS E SETAS
  percentual: {
    color: corDescricao,
    fontSize: ajustarTamanhoFonte("13px"),
    fontWeight: 600,
    flexShrink: 0,
    minWidth: 38,
    textAlign: "right",
    fontVariantNumeric: "tabular-nums",
  },

  seta: {
    color: "primary.main",
    flexShrink: 0,
    fontSize: 20,
  },

  // INTERRUPTORES
  switch: {
    // A trilha tem 40 × 24px; a área de interação inclui o respiro ao redor.
    width: 56,
    height: 40,
    p: "8px",
    flexShrink: 0,

    "& .MuiSwitch-switchBase": {
      p: "10px",
      color: "#fff",

      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",

        "& + .MuiSwitch-track": {
          opacity: 1,
          bgcolor: "var(--sear-acao-azul, #1976d2)",
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        outline: "2px solid",
        outlineColor: "var(--sear-acao-azul, #1976d2)",
        outlineOffset: 3,
      },
    },

    "& .MuiSwitch-thumb": {
      width: 20,
      height: 20,
      boxShadow: "0 1px 3px rgba(0,0,0,.18)",
    },

    "& .MuiSwitch-track": {
      opacity: 1,
      borderRadius: "12px",

      bgcolor: (theme) =>
        theme.palette.mode === "dark" ? "#53647d" : "#91a2b8",
    },
  },

  // DIVISOR INFERIOR
  divisor: {
    mx: 1.25,
    my: 1,
  },

  // RESTAURAR PREFERÊNCIAS
  restaurar: {
    ...linhaPreferencias,

    minHeight: 56,
    py: 1,
    bgcolor: (theme) =>
      theme.palette.mode === "dark" ? "rgba(47,109,176,.2)" : "#e2f2ff",

    "&:hover, &.Mui-focusVisible": {
      bgcolor: (theme) =>
        theme.palette.mode === "dark" ? "rgba(47,109,176,.3)" : "#d4eaff",
    },
  },

  iconeRestaurar: {
    width: 28,
    height: 28,
    flexShrink: 0,

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    borderRadius: 1.25,
    color: "primary.main",

    "& .MuiSvgIcon-root": { fontSize: 22 },
  },
};

// Mantém o visual aprovado e reduz apenas as dimensões das Preferências.
export const painelPreferenciasCompacto = {
  ...painelMenuPreferencias,
  width: 328,
};

export const estilosPreferenciasCompactas = {
  ...estilosMenuPreferencias,
  cabecalho: {
    ...estilosMenuPreferencias.cabecalho,
    px: 1,
    py: 0.75,
    mb: 0.25,
    gap: 1,
  },
  iconeCabecalho: { ...estilosMenuPreferencias.iconeCabecalho, width: 32, height: 32 },
  secao: { ...estilosMenuPreferencias.secao, px: 1, pt: 0.5, pb: 0.25, mt: 0.125 },
  linha: { ...linhaPreferencias, minHeight: 52, px: 1, py: 0.75, gap: 0.75 },
  switch: {
    ...estilosMenuPreferencias.switch,
    width: 44,
    height: 32,
    "& .MuiSwitch-switchBase": {
      ...estilosMenuPreferencias.switch["& .MuiSwitch-switchBase"],
      "&.Mui-checked": {
        ...estilosMenuPreferencias.switch["& .MuiSwitch-switchBase"]["&.Mui-checked"],
        transform: "translateX(12px)",
      },
    },
    "& .MuiSwitch-thumb": {
      ...estilosMenuPreferencias.switch["& .MuiSwitch-thumb"],
      width: 12,
      height: 12,
    },
  },
  divisor: { ...estilosMenuPreferencias.divisor, my: 0.75 },
  restaurar: { ...estilosMenuPreferencias.restaurar, minHeight: 48, px: 1, py: 0.75, gap: 0.75 },
};

// Variante aprovada: barras de ajuste no próprio painel de Preferências.
export const estilosPreferenciasDiretas = {
  ...estilosPreferenciasCompactas,
  linha: { ...estilosPreferenciasCompactas.linha, minHeight: 40, py: 0.625, cursor: "pointer" },
  iconeLinha: {
    ...estilosPreferenciasCompactas.iconeLinha,
    display: "flex", alignItems: "center", justifyContent: "center", width: 24, flexShrink: 0,
    "& .MuiSvgIcon-root": { fontSize: 20 },
  },
  ajuste: { mx: 1, pt: 1, pb: 0.5 },
  cabecalhoAjuste: { display: "flex", alignItems: "center", gap: 0.75 },
  barra: {
    color: "var(--sear-acao-azul, #1976d2)", height: 4, py: "10px", display: "block",
    width: "calc(100% - 12px)", mx: "6px", my: 0,
    "& .MuiSlider-thumb": { width: 12, height: 12 },
    "& .MuiSlider-thumb::after": { width: 36, height: 36 },
  },
  limitesAjuste: { display: "flex", justifyContent: "space-between" },
  restaurar: { ...estilosPreferenciasCompactas.restaurar, minHeight: 40, width: "100%", textAlign: "left" },
};

// Versão aprovada: ajustes recolhíveis e detalhes azuis no tema claro.
export const painelPreferenciasRecolhiveis = {
  ...painelPreferenciasCompacto,
  width: 304,
  mt: 0,
  right: 12,
  left: "auto",
  borderRadius: "10px",
  borderColor: (theme) => theme.palette.mode === "dark" ? theme.palette.divider : "#b8d9fa",
  borderTopColor: (theme) => theme.palette.mode === "dark" ? "#2f6db0" : "#087cf0",
};

export const estilosPreferenciasRecolhiveis = {
  ...estilosPreferenciasDiretas,
  fechar: {
    width: 26, height: 26, p: 0.5, flexShrink: 0, color: "inherit",
    "@media (pointer: coarse)": { width: 44, height: 44 },
  },
  cabecalho: {
    ...estilosPreferenciasCompactas.cabecalho,
    px: 1, py: 0.75, gap: 1, mb: 0.625, borderRadius: "6px",
    background: (theme) => theme.palette.mode === "dark"
      ? "linear-gradient(100deg, #19344f, #14263b)"
      : "linear-gradient(110deg, #2ea5fb 0%, #9bd6ff 25%, #e1effd 65%, #e1effd 100%)",
  },
  iconeCabecalho: {
    ...estilosPreferenciasCompactas.iconeCabecalho,
    width: 28, height: 28, bgcolor: "transparent",
    color: (theme) => theme.palette.mode === "dark" ? "#9bcaff" : "#075bb7",
    "& .MuiSvgIcon-root": { fontSize: 18 },
  },
  tituloCabecalho: { ...estilosMenuPreferencias.tituloCabecalho, fontSize: ajustarTamanhoFonte("16px"), color: (theme) => theme.palette.mode === "dark" ? "#fff" : "#082240" },
  tituloLinha: { ...estilosMenuPreferencias.tituloLinha, fontSize: ajustarTamanhoFonte("13px") },
  descricaoLinha: { ...estilosMenuPreferencias.descricaoLinha, fontSize: ajustarTamanhoFonte("11px") },
  linha: {
    ...estilosPreferenciasDiretas.linha,
    minHeight: 42, px: 0.75, py: 0.625, gap: 1, borderRadius: "6px",
    "&:hover": { bgcolor: (theme) => theme.palette.mode === "dark" ? "#162c44" : "#e5f2ff" },
    "@media (pointer: coarse)": { minHeight: 44 },
  },
  iconeLinha: {
    ...estilosPreferenciasDiretas.iconeLinha,
    "&&": { minWidth: 24 }, width: 24, height: 24, borderRadius: "6px",
    color: (theme) => theme.palette.mode === "dark" ? "#9bcaff" : "#fff",
    bgcolor: (theme) => theme.palette.mode === "dark" ? "#19334e" : "#087cf0",
    "& .MuiSvgIcon-root": { fontSize: 18 },
  },
  ajuste: {
    my: "1px", borderRadius: "6px",
    '&[data-aberto="true"]': { bgcolor: (theme) => theme.palette.mode === "dark" ? "#162c44" : "#e5f2ff" },
  },
  linhaAjuste: {
    display: "flex", alignItems: "center", gap: 1, minHeight: 42, width: "100%",
    px: 0.75, py: 0.625, borderRadius: "6px", textAlign: "left",
    "&:hover": { bgcolor: (theme) => theme.palette.mode === "dark" ? "#162c44" : "#e5f2ff" },
    "&.Mui-focusVisible": { outline: "2px solid", outlineColor: "primary.main", outlineOffset: -2 },
    "@media (pointer: coarse)": { minHeight: 44 },
  },
  percentual: {
    ...estilosMenuPreferencias.percentual,
    minWidth: 0, flexShrink: 0, px: 0.625, py: 0.25, borderRadius: "5px",
    fontSize: ajustarTamanhoFonte("11px"), textAlign: "center",
    color: (theme) => theme.palette.mode === "dark" ? "#fff" : "#075bb7",
    bgcolor: (theme) => theme.palette.mode === "dark" ? "#1b3956" : "#d7ebff",
  },
  seta: { fontSize: 16, flexShrink: 0, color: (theme) => theme.palette.mode === "dark" ? "#9bcaff" : "#087cf0" },
  conteudoAjuste: { pl: "38px", pr: "10px", pb: "7px" },
  barra: { ...estilosPreferenciasDiretas.barra, py: "9px" },
  divisor: { mx: 0, mt: 0.625, mb: 0.875, borderColor: (theme) => theme.palette.mode === "dark" ? theme.palette.divider : "#b8d9fa" },
  restaurar: {
    ...estilosPreferenciasDiretas.restaurar,
    minHeight: 36, px: 1, py: 0.875, gap: 1, borderRadius: "6px",
    bgcolor: (theme) => theme.palette.mode === "dark" ? "#193b5b" : "#cce7ff",
    "&:hover": { bgcolor: (theme) => theme.palette.mode === "dark" ? "#21496d" : "#b8dcff" },
    "@media (pointer: coarse)": { minHeight: 44 },
  },
  iconeRestaurar: {
    ...estilosMenuPreferencias.iconeRestaurar,
    width: 18, height: 18,
    color: (theme) => theme.palette.mode === "dark" ? "#9bcaff" : "#087cf0",
    "& .MuiSvgIcon-root": { fontSize: 18 },
  },
};
